//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionExplore(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.5898 13.59C13.9048 13.2754 14.1194 12.8745 14.2064 12.438C14.2934 12.0015 14.2491 11.5489 14.0788 11.1376C13.9086 10.7263 13.6202 10.3748 13.2502 10.1274C12.8801 9.88005 12.445 9.74802 11.9998 9.74802C11.5547 9.74802 11.1196 9.88005 10.7495 10.1274C10.3794 10.3748 10.0911 10.7263 9.92085 11.1376C9.75063 11.5489 9.70624 12.0015 9.79328 12.438C9.88033 12.8745 10.0949 13.2754 10.4098 13.59C10.8317 14.0113 11.4036 14.248 11.9998 14.248C12.5961 14.248 13.168 14.0113 13.5898 13.59ZM6.58984 6.59L3.77984 17L5.99984 16.35L8.19984 8.2L18.5898 5.41L15.7998 15.8L3.17984 19.18L2.58984 21.41L17.4398 17.41L21.4398 2.56L6.58984 6.59Z" fill="currentColor" /></svg>;
}
export default IconActionExplore;